export const TIPOS_TICKET = {
  venta: "venta"
};

export const TIPOS_CUENTA = {
  ventas: "ventas"
};

export const CART_STATUS = {
  pending: "pendiente",
  onPayment: "en pago",
  finished: "finalizado",
  canceled: "cancelado"
};

export const ORDER_STATUS = {
  inbox: 1,
  packing: 2,
  paymentPending: 9
};

export const PLANES = {
  free: { value: "free", label: "Free" },
  pro: { value: "pro", label: "Pro" },
  guru: { value: "guru", label: "Gurú" },

  get(plan) {
    switch (plan) {
      case this.free.value:
        return this.free;
      case this.pro.value:
        return this.pro;
      case this.guru.value:
        return this.free;
      default:
        return null;
    }
  }
};

export const MAX_SIGNV4_OFFSET = 300000;
